module.exports = __webpack_public_path__ + "img/right_backitem.9b39f7b3.png";